module.exports = __webpack_public_path__ + "media/images/themes/tech-and-rights-94d09d92e9538a152953fa2628c6cace.png";